import React, { FC, ReactElement } from "react";
import { CONFIG } from "../../constants";
import { Button } from "../../components";
import WindowsLogoSVG from "../../assets/windows-logo.svg?react";
import { AuthService, ToastService } from "../../services";

const ssoOptions = [
  {
    icon: <WindowsLogoSVG width={16} height={16} />,
    name: "Microsoft",
    link: "",
  },
];

function getDomainFromEmail(email) {
  if (typeof email !== "string") return null;
  const parts = email.split("@");
  return parts.length === 2 ? parts[1] : null;
}

export const SSOOptions = () => {
  const csrfInputRef = React.useRef(null);
  const formRef = React.useRef(null);
  const emailRef = React.useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    AuthService.csrf()
      .then(({ csrf }) => {
        csrfInputRef.current.value = csrf;

        const domain = getDomainFromEmail(emailRef.current.value);
        AuthService.ssologin(domain, csrf)
          .then((data) => {
            formRef.current.action = data.url;
            formRef.current.submit();
          })
          .catch((err) => {
            ToastService.error("SSO Login failed");
          });
      })
      .catch((err) => {
        ToastService.error("Login failed");
      });
  };

  return (
    <div className="flex flex-row w-full">
      {ssoOptions.map((option) => (
        <form
          className="w-full space-y-4"
          ref={formRef}
          action={option.link}
          method="POST"
          onSubmit={handleSubmit}
        >
          <input
            ref={csrfInputRef}
            type="hidden"
            name="csrfmiddlewaretoken"
            value=""
          />
          <input
            ref={emailRef}
            type="text"
            name="email"
            className="w-full p-2 rounded-md opacity-50 bg-white text-black"
            placeholder="Email"
          />
          <Button
            type="submit"
            className="w-full bg-primary text-white rounded-full"
          >
            Login with {option.name}
          </Button>
        </form>
      ))}
    </div>
  );
};
